import React from 'react';

// @mui/material components
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import CrmButton from './CrmButton';
import CrmTextField from './CrmTextField';

/*
Call this with
    <PromptModal
        show={the condition under which it should show}
        title="whatever"
        explanation="whatever"
        inputLabel="string to show as the prompt in the input label" // optional
        initialValue="string to put into input to start" // optional
        okButtonLabel="whatever" //optional, defaults to "Accept"
        onUpdatePage={(newValue) => this.handlePromptModalChange(newValue)} // (optional) to update state on the page
        onConfirm={(str) => aFunctionForAcceptingInputAndClosingTheDialog(str)}
        onCancel={aFunctionForClosingTheDialog}
    />
*/

class PromptModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.initialValue,
    };
  }

  changeValue(newValue) {
    this.setState({ value: newValue });
    if (this.props.onUpdatePage) {
      this.props.onUpdatePage(newValue);
    }
  }

  handleConfirm() {
    const newValue = this.state.value.trim();
    this.props.onConfirm(newValue);
    this.setState({ value: '' });
  }

  render() {
    if (this.state.errorMessage) {
      return <h3>{this.state.errorMessage}</h3>;
    }

    const { show, title, explanation, inputLabel, okButtonLabel, onConfirm, onCancel } = this.props;
    const realOkButtonLabel = okButtonLabel || 'Accept';
    const disabled = !this.state.value;
    return (
      <Dialog open={show} onClose={onCancel} title={title} hideButtons={false} onOk={() => onConfirm(this.state.value)}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{explanation}</DialogContentText>
          <CrmTextField
            autoFocus
            required
            label={inputLabel}
            fullWidth
            value={this.state.value}
            onChange={(event) => this.changeValue(event.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <CrmButton outlined onClick={onCancel}>
            Cancel
          </CrmButton>
          <CrmButton filled disabled={disabled} onClick={() => this.handleConfirm()}>
            {realOkButtonLabel}
          </CrmButton>
        </DialogActions>
      </Dialog>
    );
  }
}

export default PromptModal;
